import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_GREY,
    codeProp: 'taskNo',
    detailUrl: '/DesDetail',
    detailIdProp: 'desId',
    mapProp: 'desMap',
    name: '需求确认单',
    textProp: 'desTitle',
    type: 'DES',
}
